import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { deleteCacheEntry } from './deleteCacheEntry';

/**
 * Deletes all references to Cart from the apollo cache including entries that
 * start with "$" which were automatically created by Apollo InMemoryCache.
 *
 * @param {ApolloClient} client
 */
export var clearCartDataFromCache = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (client) {
    yield deleteCacheEntry(client, key => key.match(/^\$?Cart/));

    // Any cart subtypes that have key fields must be manually cleared.
    // TODO: we may be able to use cache.evict here instead.
    yield deleteCacheEntry(client, key => key.match(/^\$?AppliedGiftCard/));
    yield deleteCacheEntry(client, key => key.match(/^\$?ShippingCartAddress/));
    yield deleteCacheEntry(client, key => key.match(/^\$?AvailableShippingMethod/));
  });
  return function clearCartDataFromCache(_x) {
    return _ref.apply(this, arguments);
  };
}();